<mdb-form-control [formGroup]="formGroup()">
  <mdb-select
    [value]="defaultValue()"
    [clearButton]="clearButton()"
    formControlName="{{ controlName() }}"
    >
    @for (type of enum() | keyvalue; track type) {
      <mdb-option [value]="type.value">
        {{ castFunction() ? (castFunction()!(type.value) | translate) : (castToString(type.value) | translate) }}
      </mdb-option>
    }
  </mdb-select>
  <label mdbLabel class="form-label">
    {{ label() | translate }} @if (isRequired()) {
    <span>*</span>
  }
</label>
  @if (
    isRequired() &&
    control?.hasError('required') &&
    (control?.dirty || control?.touched)
    ) {
    <mdb-error
      >{{ label() | translate }}
      {{ 'VALIDATION.IS_REQUIRED' | translate }}.
    </mdb-error>
  }
</mdb-form-control>
